import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { getBranchesLatest } from '../../store/actions';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import './styles.scss'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../classetComponents/classetCalender';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';

class StudentAttendanceReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            filteredUsers: [],
            selectedStudents: [],
            status: null,
            dateRange: new Date(), // Initialize with today's date
        }
        this.service = new Service()
    }
    setDropdownValues = (dropdownsData) => {
        const branchChanged = this.state.dropdownsData?.branchIds !== dropdownsData.branchIds;
        this.setState({
            dropdownsData,
            branchChanged,
            studentsList: [],
            selectedStudents: [],
            dateRange: null
        }, () => {
            if (this.state.dropdownsData?.sectionIds?.length > 0) {
                this.filtersUsersData()
            }

        });
    }
    handleStudentChange = (e) => {
        this.setState({
            selectedStudents: e.value
        }, () => {
            this.filtersUsersData(false);
        });
    }
    handleDateRangeChange = (e) => {
        this.setState({
            dateRange: e.value
        }, () => {
            this.filtersUsersData(false);
        });
    }
    filtersUsersData = (isSelectedStudent = true) => {
        const { users, dropdownsData, lazyParams, selectedStudents, dateRange } = this.state;
        let filteredUsers = users?.map((user) => {
            let modifiedUser = { ...user };

            // Always use dateRange (which defaults to today)
            const selectedDate = moment(dateRange).startOf('day');
            const foundRecord = user.attendance.dailyRecords.find(record =>
                moment(record.date).isSame(selectedDate, 'day')
            );

            modifiedUser.currentAttendance = foundRecord || {
                date: selectedDate.toISOString(),
                status: '-'
            };

            return modifiedUser;
        }).filter((user) => {
            if (dropdownsData?.sectionIds?.length > 0 &&
                !dropdownsData.sectionIds.includes(user.student.sectionId)) {
                return false;
            }

            if (selectedStudents?.length > 0 &&
                !selectedStudents.includes(user.student.user_id)) {
                return false;
            }

            return true;
        });

        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 10;
        const paginatedUsers = filteredUsers?.slice(first, first + rows);

        let studentsFilter;
        if (isSelectedStudent) {
            studentsFilter = filteredUsers?.map((user) => ({
                user_id: user.student.user_id,
                studentName: `${user.student.firstName} ${user.student.lastName}`
            }));
        }

        this.setState({
            filteredUsers: paginatedUsers,
            totalRecords: filteredUsers?.length || 0,
            studentsList: studentsFilter || this.state.studentsList,
        });
    }
    fetchUsersData = () => {
        let academicYear = localStorage.getItem("userAcademicYear")
        const url = `${baseUrlAdmin}/studentReports/attendanceInfo`;
        let payload = {
            academicYear
        }
        this.setState({ isLoading: true })
        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    users: res.res.data,
                    totalRecords: res.res.totalRecords
                }, () => this.filtersUsersData());
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }
    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, () => {
            this.filtersUsersData();
        });
    }

    exportToExcel = () => {
        const { users, dropdownsData, selectedStudents, dateRange } = this.state;

        // Get complete filtered data without pagination
        let completeFilteredData = users?.map((user) => {
            let modifiedUser = { ...user };
            const selectedDate = moment(dateRange).startOf('day');
            const foundRecord = user.attendance.dailyRecords.find(record =>
                moment(record.date).isSame(selectedDate, 'day')
            );

            modifiedUser.currentAttendance = foundRecord || {
                date: selectedDate.toISOString(),
                status: '-'
            };
            return modifiedUser;
        }).filter((user) => {
            if (dropdownsData?.sectionIds?.length > 0 &&
                !dropdownsData.sectionIds.includes(user.student.sectionId)) {
                return false;
            }
            if (selectedStudents?.length > 0 &&
                !selectedStudents.includes(user.student.user_id)) {
                return false;
            }
            return true;
        });

        // Format data for export
        const exportData = completeFilteredData.map(user => ({
            'Student Name': `${user.student.firstName} ${user.student.lastName}`,
            'Enrollment No.': user.student.enrollmentId,
            'Branch': user.student.branchName,
            'Board': user.student.boardName,
            'Class': user.student.className,
            'Section': user.student.sectionName,
            'Attendance Date': moment(user.currentAttendance.date).format('DD-MM-YYYY'),
            'Attendance Status': user.currentAttendance.status,
            'Total Attendance %': `${user.attendance.percentage}%`
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

        // Generate and download file
        XLSX.writeFile(workbook, `Student_Attendance_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    componentDidMount() {
        this.fetchUsersData();
    }

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };
        return (
            <>

                <div style={containerStyle} className=' m-2'>
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToSectionMultiDDTillSecReports
                            setValues={this.setDropdownValues}
                            showTooltip={false}
                            tooltip={null}
                            tooltipOptions={{ disabled: true }}
                        />
                        <div className="grid my-2 mx-1">
                            <div className='col-3'>
                                <p className='filter-title'>Student Name/Enrollment Number</p>
                                <ClassetMultiSelect
                                    options={this.state.studentsList}
                                    value={this.state.selectedStudents}
                                    optionValue='user_id'
                                    optionLabel='studentName'
                                    onChange={this.handleStudentChange}
                                    placeholder="Select Student"
                                    tooltip={null}
                                    showTooltip={false}
                                    tooltipOptions={{ disabled: true }}
                                />
                            </div>
                            <div className='col-3'>
                                <p className='filter-title'>Date</p>
                                <ClassetCalendar
                                    selectionMode={'single'}
                                    readOnlyInput
                                    value={this.state.dateRange}
                                    onChange={this.handleDateRangeChange}
                                    placeholder="Select a date"
                                />
                            </div>

                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button label="View Analysis" className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
                            </div>
                        </div>
                    </div>

                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.filteredUsers}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column
                                field="student.firstName"
                                header="Student Name"
                                body={(rowData) => {
                                    const formatName = (name) => {
                                        return name
                                            ? name.toLowerCase().split(' ')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')
                                            : '';
                                    };
                                    const firstName = formatName(rowData.student.firstName);
                                    const lastName = formatName(rowData.student.lastName);
                                    return <p className="m-0">{`${firstName} ${lastName}`}</p>;
                                }}
                            />
                            <Column
                                header="Enrollment No."
                                field="student.enrollmentId"

                            />
                            <Column header="Branch" field="student.branchName" />
                            <Column header="Board" field="student.boardName" />
                            <Column header="Class" field="student.className" />
                            <Column header="Section" field="student.sectionName" />
                            <Column header="Attendance Date"
                                body={(rowData) => (
                                    <p className="m-0">{rowData?.currentAttendance?.date ? moment(rowData.currentAttendance.date).format('DD-MM-YYYY') :
                                    moment(new Date()).format('DD-MM-YYYY')
                                    }</p>
                                )}></Column>
                            <Column
                                header="Attendance Status"
                                body={(rowData) => {
                                    console.log(rowData, "Attendance Status");
                                    const status = rowData.currentAttendance.status;
                                    const getStatusColor = (status) => {
                                        switch (status.toUpperCase()) {
                                            case 'PRESENT': return 'green';
                                            case 'ABSENT': return 'red';
                                            case 'HALF DAY': return '#E99B06';
                                            default: return 'inherit';
                                        }
                                    };
                                    return (
                                        <p className="m-0" style={{
                                            color: getStatusColor(status),

                                        }}>
                                            {status}
                                        </p>
                                    );
                                }}
                            />
                            <Column
                                header="Total Attendance %"
                                body={(rowData) => {
                                    const percentage = rowData.attendance.percentage;
                                    const textColor = percentage < 75 ? 'red' :
                                        percentage > 90 ? 'green' :
                                            'inherit';
                                    return (
                                        <p className="m-0" style={{ color: textColor, fontWeight: 'bold' }}>
                                            {percentage}%
                                        </p>
                                    );
                                }}
                            />
                        </DataTable>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>

        )
    }
}

const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(StudentAttendanceReport)));